module.exports = __webpack_public_path__ + "img/instagram-post.da9078b3.png";